<template>
  <div>
    <div v-for="(element, key) in content" v-bind:key="key" class="pl-5">
      <span class="text-capitalize font-weight-medium">{{ nameLabel(key) }}</span>:&nbsp;
      <span v-if="!Array.isArray(element) && typeof element != 'object'">{{ parseValue(element) }}</span>
      <span v-else-if="Array.isArray(element) && typeof element[0] != 'object'">{{ element }}</span>
      <recursive-label v-else :content="element" />
    </div>
  </div>
</template>

<script>
export default {
    name: 'ResursiveLabel',
    props: ['content'],
    methods: {
      nameLabel(stateName) {
        if (typeof stateName === 'string') {
          return stateName.replace(/_/g, ' ')
        } else if (typeof stateName === 'number') {
          return stateName
        } else if (typeof stateName === 'object') {
          return 'Object'
        }
        return typeof stateName
      },
      
      parseValue(value) {
        if (value === undefined) {
          return 'undefined'
        } else if (typeof(value) == 'object') {
          return 'Object (' + JSON.stringify(value) + ')'
        }
        return this.$helpers.getLabel(value)
      },
    }
  }
</script>